// extracted by mini-css-extract-plugin
export default {"Container":"ResolveTicket_Container__vRdTe","HeaderRight":"ResolveTicket_HeaderRight__Q5oeG"};